var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalAntibioticGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 674.9 494.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: url(#radial-gradient1);\r\n      }\r\n\r\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .st26 {\r\n        fill: #6e7ab9;\r\n      }\r\n\r\n      .st27 {\r\n        fill: url(#linear-gradient2);\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#linear-gradient9);\r\n      }\r\n\r\n      .st2 {\r\n        fill: url(#linear-gradient10);\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#linear-gradient14);\r\n      }\r\n\r\n      .st3, .st8, .st9, .st10, .st11, .st28, .st13, .st14, .st15, .st21, .st25 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st3, .st9, .st10, .st11, .st13, .st21, .st25 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .st3, .st10, .st11, .st13, .st21, .st25 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .st29 {\r\n        fill: #107cbf;\r\n      }\r\n\r\n      .st30 {\r\n        fill: #092d45;\r\n      }\r\n\r\n      .st4 {\r\n        fill: url(#radial-gradient3);\r\n      }\r\n\r\n      .st31 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st32 {\r\n        fill: #f0f0f0;\r\n      }\r\n\r\n      .st33 {\r\n        fill: #2896ce;\r\n      }\r\n\r\n      .st5 {\r\n        fill: url(#radial-gradient2);\r\n      }\r\n\r\n      .st34 {\r\n        fill: #083b5a;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #59c6fc;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st35, .st22 {\r\n        fill: #ccecff;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #afa4c6;\r\n        opacity: .3;\r\n      }\r\n\r\n      .st8, .st14 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .st9, .st15 {\r\n        fill: #fbf9fa;\r\n        mix-blend-mode: soft-light;\r\n      }\r\n\r\n      .st36 {\r\n        fill: #565f8f;\r\n      }\r\n\r\n      .st10 {\r\n        fill: url(#linear-gradient16);\r\n      }\r\n\r\n      .st37 {\r\n        fill: #0a6491;\r\n      }\r\n\r\n      .st11 {\r\n        fill: url(#linear-gradient15);\r\n      }\r\n\r\n      .st38 {\r\n        fill: #282828;\r\n      }\r\n\r\n      .st12 {\r\n        fill: url(#linear-gradient8);\r\n      }\r\n\r\n      .st39 {\r\n        fill: url(#linear-gradient4);\r\n      }\r\n\r\n      .st13 {\r\n        fill: url(#linear-gradient17);\r\n      }\r\n\r\n      .st14 {\r\n        fill: url(#linear-gradient6);\r\n      }\r\n\r\n      .st15 {\r\n        opacity: .6;\r\n      }\r\n\r\n      .st16 {\r\n        fill: url(#linear-gradient11);\r\n      }\r\n\r\n      .st40 {\r\n        fill: url(#linear-gradient5);\r\n      }\r\n\r\n      .st41 {\r\n        fill: #8da5b2;\r\n      }\r\n\r\n      .st17 {\r\n        fill: url(#linear-gradient7);\r\n      }\r\n\r\n      .st18 {\r\n        fill: #0262ab;\r\n      }\r\n\r\n      .st42 {\r\n        fill: #e4edef;\r\n      }\r\n\r\n      .st43 {\r\n        fill: #3287b2;\r\n      }\r\n\r\n      .st44 {\r\n        fill: #939c9e;\r\n      }\r\n\r\n      .st45 {\r\n        fill: #c7c7c7;\r\n      }\r\n\r\n      .st46 {\r\n        fill: #b9c0c2;\r\n      }\r\n\r\n      .st47 {\r\n        fill: #f4f4f4;\r\n      }\r\n\r\n      .st48 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .st49 {\r\n        fill: #095e89;\r\n      }\r\n\r\n      .st19 {\r\n        fill: url(#linear-gradient12);\r\n      }\r\n\r\n      .st50 {\r\n        fill: #a9b0b2;\r\n      }\r\n\r\n      .st51 {\r\n        fill: #acb3b5;\r\n      }\r\n\r\n      .st52 {\r\n        fill: #161615;\r\n      }\r\n\r\n      .st53 {\r\n        fill: #ececec;\r\n      }\r\n\r\n      .st20 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .st21 {\r\n        fill: url(#linear-gradient18);\r\n      }\r\n\r\n      .st23 {\r\n        fill: url(#linear-gradient3);\r\n      }\r\n\r\n      .st24 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .st25 {\r\n        fill: url(#linear-gradient13);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -132.3,
    y1: 515.7,
    x2: -132.3,
    y2: 564.6,
    gradientTransform: "translate(-43.1 529.1) rotate(-160.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a49ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c7df"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -131.8,
    cy: -399.8,
    fx: -131.8,
    fy: -399.8,
    r: 31.5,
    gradientTransform: "translate(267.9 -333.2) rotate(-160.2) scale(1 .9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d7c6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdafd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -115.7,
    y1: 515.4,
    x2: -115.7,
    y2: 565.3,
    gradientTransform: "translate(-291.5 -55.8) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6cee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4efff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -115.1,
    y1: 517.1,
    x2: -115.1,
    y2: 563.6,
    gradientTransform: "translate(-292 -55.4) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2dceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: -115.2,
    cy: 2537,
    fx: -115.2,
    fy: 2537,
    r: 17.6,
    gradientTransform: "translate(-997.1 3180.4) rotate(-160.2) scale(1 1.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdafd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -186.1,
    y1: 443.6,
    x2: -186.1,
    y2: 471.8,
    gradientTransform: "translate(117.7 495.6) rotate(-177.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: -186.3,
    cy: -499.2,
    fx: -186.3,
    fy: -499.2,
    r: 18.2,
    gradientTransform: "translate(150.8 -420.1) rotate(-177.9) scale(1 .9)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: -176.5,
    y1: 443.4,
    x2: -176.5,
    y2: 472.2,
    gradientTransform: "translate(-147 -132) rotate(-90)",
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -176.2,
    y1: 444.4,
    x2: -176.2,
    y2: 471.2,
    gradientTransform: "translate(-147.3 -131.7) rotate(-90)",
    xlinkHref: "#linear-gradient2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: -176.8,
    cy: 2472,
    fx: -176.8,
    fy: 2472,
    r: 10.1,
    gradientTransform: "translate(14.8 3311.8) rotate(-177.9) scale(1 1.3)",
    xlinkHref: "#radial-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 527.8,
    y1: 92.7,
    x2: 608.7,
    y2: 92.7,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d697e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede5f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 520.5,
    y1: 99.7,
    x2: 620.2,
    y2: 122.1,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7b5e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 564.5,
    y1: 106,
    x2: 574.3,
    y2: 136.1,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 564.8,
    y1: 110.3,
    x2: 575,
    y2: 141.6,
    xlinkHref: "#linear-gradient8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 527.6,
    y1: 115.6,
    x2: 614,
    y2: 135,
    xlinkHref: "#linear-gradient7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 505.5,
    y1: -14.9,
    x2: 581.4,
    y2: 1.3,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 593.2,
    y1: -9.4,
    x2: 637.6,
    y2: 0,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0d1eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 609.9,
    y1: -3.1,
    x2: 624.1,
    y2: -3.1,
    gradientTransform: "translate(-78.3 417.8) rotate(-4.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7ac75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 534,
    y1: -63.8,
    x2: 534,
    y2: 88.9,
    xlinkHref: "#linear-gradient13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: -21,
    y1: 511.3,
    x2: -21,
    y2: 520.1,
    gradientTransform: "translate(114.8 274.2) rotate(74.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5efe5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: -43.6,
    y1: 495.1,
    x2: -3.8,
    y2: 495.1,
    gradientTransform: "translate(114.8 274.2) rotate(74.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5efe5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 234.1,
    y1: 587.2,
    x2: 234.1,
    y2: 592.9,
    gradientTransform: "translate(-55.1 233.5) rotate(58.3) scale(1 -1)",
    xlinkHref: "#linear-gradient15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 219.6,
    y1: 576.8,
    x2: 245.2,
    y2: 576.8,
    gradientTransform: "translate(-55.1 233.5) rotate(58.3) scale(1 -1)",
    xlinkHref: "#linear-gradient16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M106.6,154.4c7.3-32.6,34.5-55.5,73.6-60.4,99.4-12.5,66.3-35.5,129.2-65.7,97.6-47,101.4,68.1,198.8,57.8,59.7-6.4,152.3,48.1,100.4,106.5-59.2,66.6-14.1,89-38.3,151.1-27.9,72.2-89.7,61.7-133.1,69.4-46,8.2-70.4,69.1-137.1,59.1-52.9-7.9-41.1-60.8-157.6-70.3-64.8-5.3-105.8-73-71.2-118.1,53.7-70.1,23.7-77.7,35.2-129.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M619.6,454.1c3.1,0,5.6,2.4,5.6,5.3h0c0,2.9-2.5,5.3-5.6,5.3H37.2c-3.1,0-5.6-2.4-5.6-5.3h0c0-2.9,2.5-5.3,5.6-5.3h582.4ZM668.4,454.1c-2.9,0-5.3,2.4-5.3,5.3h0c0,2.9,2.4,5.3,5.3,5.3h0c2.9,0,5.3-2.4,5.3-5.3h0c0-2.9-2.4-5.3-5.3-5.3h0ZM641.7,454.1c-2.9,0-5.3,2.4-5.3,5.3h0c0,2.9,2.4,5.3,5.3,5.3h8.8c2.9,0,5.3-2.4,5.3-5.3h0c0-2.9-2.4-5.3-5.3-5.3h-8.8ZM5.9,454.1c-1.4,0-2.6,2.4-2.6,5.3h0c0,2.9,1.2,5.3,2.6,5.3h15.1c1.4,0,2.6-2.4,2.6-5.3h0c0-2.9-1.2-5.3-2.6-5.3H5.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M259.2,38.1s6.8,1.6,13.1,5.6c0,0,11.9,8.9,5.5,26.7-6.2,17.2-21.9,17.7-21.9,17.7,0,0-7-1-13-4.7l16.3-45.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M257.3,36.5s7,1.6,13.6,5.8c0,0,12.4,9.3,5.7,27.7-6.4,17.9-22.7,18.3-22.7,18.3,0,0-7.2-1.1-13.5-4.9l16.9-46.9h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st31",
    cx: 248.9,
    cy: 59.9,
    rx: 24.9,
    ry: 17.8,
    transform: "translate(108.2 273.8) rotate(-70.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 248.3,
    cy: 59.7,
    rx: 23.2,
    ry: 16.6,
    transform: "translate(108 273.1) rotate(-70.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,37.4l-18.1,46.2c-1.8-.6-3.2-1.2-4.8-2.4l17.2-45.6s3.8.7,4.3.9c.8.3.9.5,1.4.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "253.7 35.7 258 36.7 239.1 82.8 236.5 81.3 253.7 35.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M267.1,84.2l-2.7.8-10.4-3.7s-6.2,4.6-13.6,2.1c0,0,5,3.3,13.5,4.9,0,0,6.9.2,13.2-4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M279.2,55.2l-12-5.7s-.8-5.7-5.1-10.1l11.1,5s5,5.6,6,10.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M312.6,30.7s4-.3,8.2.8c0,0,8.1,2.8,7.7,13.7-.4,10.6-8.9,13.5-8.9,13.5,0,0-4,.6-8-.3l1-27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.3,30.1s4.2-.3,8.5.8c0,0,8.4,2.9,8,14.2-.4,11-9.3,14.1-9.3,14.1,0,0-4.2.7-8.3-.3l1-28.8h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st39",
    cx: 310.8,
    cy: 44.5,
    rx: 14.4,
    ry: 10.3,
    transform: "translate(255 353.5) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st40",
    cx: 310.5,
    cy: 44.5,
    rx: 13.4,
    ry: 9.6,
    transform: "translate(254.7 353.2) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.6,30.3l-1.8,28.6c-1.1,0-2-.1-3-.5l1.4-28.1s2.2-.3,2.5-.3c.5,0,.6.1.9.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "309.2 30.4 311.7 30.1 309.4 58.8 307.7 58.4 309.2 30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M325.1,54.7l-1.3.9-6.4-.2s-2.6,3.6-7.1,3.6c0,0,3.3.9,8.3.3,0,0,3.8-1.1,6.5-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M326.6,36.6l-7.6-1s-1.4-3-4.6-4.6l7,.8s3.7,2.2,5.2,4.9Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M57.3,307.1h0c0,.9.2,1.7.3,2.5v.2c.2.8.4,1.5.6,2.3v.3c.3.7.6,1.3.9,2l.2.5c.3.6.7,1.2,1,1.7l.4.6c.4.5.8,1,1.2,1.5l.5.6c.4.5.9.9,1.4,1.4l.6.5c.3.3.7.5,1.1.8l-1.1-.7v17.3c-9.9-9.5-7.2-33.5-7.2-33.5h0c0,.7,0,1.4,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M596.6,245.8h-.1c0,.5.1,1.1.1,1.6,0,6.5-3.2,13.1-9.6,16.9l-298.8,179.9c-6.3,3.8-14.2,3.8-20.4,0l-101.1-61.2,100.1,60.7v17.4s-201.6-122.2-201.6-122.2c.5.5,1.1.9,1.7,1.3l200.9,121.6c6.3,3.8,14.1,3.8,20.4,0l298.8-179.9c12.7-7.7,9.6-36.1,9.6-36.1ZM584.8,283.2l-294,177.1v-17.4s294-177.1,294-177.1v17.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "290.8 442.8 584.8 265.8 584.8 283.2 290.8 460.3 290.8 442.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M539.7,231.7l-33.3-20.2,17.6-10.6v-6.7s-18.3-11.1-18.3-11.1l1.5-.9,60,36.3-7.7-4.6c-6.4,6.2-13,12.1-19.8,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M427,135.5l-23.1,14-42.7-25.8L68.7,301.1l37.3,22.5c-16.8-5-33.1-11.3-48.6-19.2,0,.9,0,1.7,0,2.6,0-.7,0-1.4,0-2.2.3-6.2,3.4-12.4,9.5-16.1L365.7,108.9c6.3-3.8,14.2-3.8,20.4,0l60.4,36.6-1.5.9-18.1-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M64.5,321c.4.3.8.6,1.2.8h0c-.4-.3-.7-.6-1.1-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M62.5,319.2c.4.5.9.9,1.4,1.4-.5-.4-1-.9-1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M62,318.6c-.4-.5-.8-1-1.2-1.5.4.5.8,1,1.2,1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "267.7 444.3 166.6 383.1 166.5 383 267.7 444.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.9,242.6c-.3,1.1-.4,2.1-.5,3.2,0,.6-.1,1.1-.1,1.7,0-1.6.2-3.3.6-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M57.7,309.6c-.2-.8-.3-1.6-.3-2.5,0,.8.2,1.7.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M60.5,316.5c-.4-.6-.7-1.1-1-1.7.3.6.7,1.2,1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M59.2,314.3c-.3-.7-.6-1.3-.8-2,.2.7.5,1.3.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M58.3,312c-.2-.7-.4-1.5-.6-2.3.2.8.4,1.5.6,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M596.6,247.5c0,6.5-3.2,13.1-9.6,16.9l-298.8,179.9c-6.3,3.8-14.2,3.8-20.4,0l-101.2-61.3-100.8-61.1c-.4-.3-.8-.5-1.2-.8l-.6-.5c-.5-.4-1-.9-1.4-1.4l-.5-.6c-.4-.5-.8-1-1.2-1.5l-.4-.6c-.4-.6-.7-1.1-1-1.7l-.2-.5c-.3-.7-.6-1.3-.8-2v-.3c-.3-.7-.5-1.5-.7-2.3v-.2c-.2-.8-.3-1.6-.3-2.5h0c0-.9,0-1.8,0-2.6,15.5,7.9,31.8,14.2,48.6,19.2l177.5,107.4,292.5-177.4-36.3-22c6.8-5.7,13.4-11.6,19.8-17.8l7.7,4.6,19.9,12c4.8,2.9,7.8,7.3,8.9,12.1.4,1.6.6,3.2.6,4.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "65.6 321.8 65.7 321.9 166.5 383 166.6 383.1 266.7 443.8 266.7 461.2 65.1 339 64.4 338.6 64.4 338.4 64.4 321.1 65.6 321.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M539.7,231.7l-33.3-20.2-24.1,14.6-97-58.7v-6.7l18.6-11.3-42.7-25.8L68.7,301.1l37.3,22.6,177.5,107.4,292.5-177.4-36.3-22ZM331.8,370.9l-71.4-44.7,6.8-3.2,70.9,44.3-6.3,3.7ZM343.9,364.3l-162.3-102.6,6.8-3.2,161.8,102.2-6.3,3.7ZM355.3,356.8l-162.3-102.6,6.8-3.2,161.8,102.2-6.3,3.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "385.3 167.4 385.3 160.7 482.3 219.4 524 194.2 524 200.9 506.4 211.5 482.3 226.1 385.3 167.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M512.8,177c.5-.8.8-1.6,1.1-2.4-.3.8-.7,1.6-1.1,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M508.2,181.6c.9-.5,1.7-1.2,2.4-1.8-.7.7-1.5,1.3-2.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M510.9,179.5c.6-.7,1.2-1.4,1.7-2.1-.5.7-1,1.5-1.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M514,165.6c-.3-.9-.7-1.7-1.2-2.6.5.8.9,1.7,1.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M514.7,168.5c0-.9-.3-1.8-.6-2.7.3.9.5,1.8.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M514,174.2c.3-.9.5-1.8.6-2.7-.1.9-.3,1.8-.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M514.7,171.5c.1-1,.1-1.9,0-2.9,0,1,0,1.9,0,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M512.7,162.8c-.5-.8-1.1-1.6-1.8-2.3.7.7,1.3,1.5,1.8,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M504.4,172.9l-7.8,4.7-51.6-31.2,1.5-.9,8.1-4.9c7.3-5.1,15.3-5.1,24.9.3l28.7,17.5c1,.6,1.9,1.3,2.7,2.1.3,4.7-1.9,9.6-6.5,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M496.6,177.6l7.8-4.7c4.6-2.8,6.8-7.7,6.5-12.4h0c.7.7,1.3,1.5,1.8,2.3v.2c.6.8,1,1.7,1.3,2.6v.2c.4.9.6,1.8.7,2.7h0c0,1.1,0,2,0,3h0c-.1.9-.3,1.8-.6,2.7v.3c-.4.8-.8,1.6-1.2,2.4l-.2.4c-.5.7-1,1.5-1.7,2.1l-.3.3c-.7.7-1.5,1.3-2.4,1.8l-1,.6-1.5.9-9.1-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M524,194.2l-18.3-11.1-9.1-5.5-51.6-31.2-18.1-10.9-23.1,14-18.6,11.2,97,58.7,41.7-25.2ZM470,194.9c0-4.9,7.4-8.8,16.6-8.8s16.6,3.9,16.6,8.8c0,4.9-7.4,8.8-16.6,8.8-9.2,0-16.6-3.9-16.6-8.8ZM441.5,157.3c0,4.9-7.4,8.8-16.6,8.8s-16.6-3.9-16.6-8.8c0-4.9,7.4-8.8,16.6-8.8s16.6,3.9,16.6,8.8ZM450.8,162c.4,0,26.7,16.8,26.7,16.8l-22.8,13.2-27.1-16.9s22.9-13.2,23.2-13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M486.6,186.1c9.2,0,16.6,3.9,16.6,8.8,0,4.9-7.4,8.8-16.6,8.8-9.2,0-16.6-3.9-16.6-8.8,0-4.9,7.4-8.8,16.6-8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M441.5,157.3c0,4.9-7.4,8.8-16.6,8.8s-16.6-3.9-16.6-8.8c0-4.9,7.4-8.8,16.6-8.8s16.6,3.9,16.6,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M477.5,178.8l-22.8,13.2-27.1-16.9s22.9-13.2,23.2-13.2c.4,0,26.7,16.8,26.7,16.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "298.1 191 321.3 177.8 348 194.6 325.2 207.9 298.1 191"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "355.4 203.6 362.2 200.3 486.7 278.9 480.4 282.6 355.4 203.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "474.6 285.5 468.2 289.2 396.4 244.2 403.2 240.9 474.6 285.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "260.3 215.7 283.5 202.5 310.2 219.3 287.4 232.6 260.3 215.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "317.3 228.4 324.2 225.1 448.7 303.8 442.4 307.4 317.3 228.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "365.2 265.7 436.5 310.3 430.2 314 358.4 269 365.2 265.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "243.9 227.2 270.6 244 247.8 257.2 220.7 240.4 243.9 227.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "284.4 250 408.9 328.6 402.6 332.3 277.5 253.3 284.4 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "320 295.7 390.9 340 384.6 343.7 313.2 299 320 295.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "181.7 261.8 188.5 258.5 350.2 360.7 343.9 364.3 181.7 261.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "193.1 254.3 199.9 251 361.6 353.2 355.3 356.8 193.1 254.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "260.4 326.1 267.3 322.9 338.1 367.2 331.8 370.9 260.4 326.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "303.2 394.8 231.8 350.1 238.6 346.9 309.5 391.2 303.2 394.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M274.7,117.6v-.3s0,.3,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M272.9,120.3l.4-.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M271.1,119.4c-.6-1.2-1.5-1.8-2.3-2.2,1.9-.6,5.4-1.5,6-.5v.3c-1.1,1-2.3,1.8-3.6,2.6v-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "271.7 121.7 271.7 121.7 271.7 121.7 271.7 121.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M272.1,121.2l.4-.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M273.7,119.4l.3-.5-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M274.3,118.4l.2-.4-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M274.8,117.2v.3s-.2.4-.2.4l-.2.4-.3.5-.3.5-.4.5-.4.5-.4.5-.4.4-.4.4h0c0-.6-.1-1.3-.5-2.1,1.3-.8,2.5-1.6,3.6-2.6h0s0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st53",
    x: 247.5,
    y: 148.8,
    width: 0,
    height: 0,
    transform: "translate(-25.3 54.2) rotate(-11.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M271.1,119.4c-.4.3-11.1,15.1-20.4,18.9-1.6.7-4.8-2.9-6.2-3h0c-4.6-6.8-10.6-8.9-10.6-9h0s33.3-9.7,33.3-9.7c0,0,.8,0,1.7.5.8.4,1.7,1,2.3,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M247.5,148.7c.2-.8,1.7-5.8-2.5-12.4-.2-.3-.4-.6-.6-.9,1.4,0,4.6,3.6,6.2,3,9.3-3.8,20-18.6,20.4-18.9v.2c.5.7.6,1.5.6,2.1h0c0,1.1-.4,1.8-.4,1.8l-23.7,25.3h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M188.9,169.2c-34,20.8-72.9,44.7-85.4,52.3h0c-4.2-6.2-10.9-8.7-10.9-8.7l85.9-52.6s5.3.8,10.3,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M244.4,135.2c-1.4.9-4.1,2.5-7.8,4.7h0c-4.4-6.2-11.2-8.5-11.2-8.5l-41.3,25.3,49.6-30.3h0s6,2.2,10.6,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M103.5,221.6h0c12.4-7.6,51.4-31.5,85.4-52.3h0s0,0,0,0c5.1,8.3,3.4,13.3,3.3,13.3l-85.9,52.6h0c.1-.3,2.4-5.8-2.8-13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M236.7,140.1v-.2c3.5-2.2,6.2-3.9,7.7-4.7h0c.2.4.4.7.6,1,4.2,6.6,2.7,11.7,2.5,12.4h0c0,0,0,0,0,0l-8.3,5.1s1.8-7.6-2.5-13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M236.6,140h0s.1.2.1.2c-9.5,6-37.8,23.1-47.8,29.1h0c-5.1-8.3-10.3-9.1-10.3-9.1h0l5.7-3.5,41.3-25.3s6.8,2.3,11.2,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M188.9,169.3h0c10-6,38.3-23.2,47.8-29.2,4.3,6.2,2.5,13.7,2.5,13.7h0s-46.9,28.7-46.9,28.7h0s1.7-5.1-3.3-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M94.3,242.6l-.6.4-.6.3h.2c.4-.3.7-.5,1.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M103.5,221.5c-3.9,2.3-8.1,4.5-12.1,6.4-3.7-5.5-9-8.4-12.2-6.8l.8-.6,12.7-7.8s6.7,2.5,10.9,8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M88,243.7c-1-.3-1.9-.7-2.7-1.4.9.6,1.8,1.1,2.7,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M91.9,228.6l-.5-.7c4-1.9,8.2-4.1,12.1-6.4h0s0,0,0,0c5.3,7.8,2.9,13.4,2.8,13.7h0c-1.4.9-3.6,2.2-5.8,3.5l-1,.6c-.3.2-.7.4-1,.6l-.9.5h0s-.8.5-.8.5c-1.5.9-2.5,1.5-2.5,1.5h0c-.4.3-.7.4-1.1.6,2.8-2.4,2.3-8.7-1.3-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M91.4,227.9l.5.7c3.6,5.8,4.1,12.1,1.3,14.5h-.2c0,.1-.3.4-.3.4-1.3.8-3,.8-4.7.1-.9-.3-1.8-.8-2.7-1.4-2-1.4-4-3.4-5.6-6-3.8-6.1-4.2-12.8-.9-14.9h.3c3.2-1.8,8.5,1.1,12.2,6.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M522.2,282.4l-.7-10.3-40.3,2.9-40.3,2.9.7,10.3c-14.6,12.8-16.1,30.3-16.1,30.3l13.5,124.1s16.8,8.8,54.6,6c40.8-2.9,54.4-13.7,54.4-13.7l-5.5-124.9s-4-17-20.3-27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M441.6,288.2s16.6,3.7,41.9,1.9c25.3-1.8,38.8-7.7,38.8-7.7l-.4-5.7-80.7,5.3.4,6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M430.1,260l3.5,20.9s11.4,4.2,48.1,1.6c36.6-2.6,48.9-8.5,48.9-8.5l1.3-21.2s-17.6,4.5-53.9,7.1c-36.3,2.6-48,.2-48,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M430.1,260s47.2-15.5,101.8-7.3c0,0-17,4.5-53.9,7.1-36.9,2.7-48,.2-48,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.1,257.7l-2.1-5.1s42.8-11.4,90.4-7l-.8,7.5s-16,2.3-45.6,4.5c-29.6,2.1-41.8.2-41.8.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M436,252.6s17,1.3,44.7-.7,45.7-6.3,45.7-6.3l-.6,6.4s-14.7,3.9-45.8,6.1c-27.6,2-41.6.1-41.6.1l-2.4-5.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "435.4 279.7 432.7 261.6 434.1 261.5 436.4 279.6 435.4 279.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "444 281.2 441.3 263.1 442.6 263 445 281.1 444 281.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "453.4 281.5 450.7 263.4 452.1 263.3 454.4 281.5 453.4 281.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "463.3 281.5 460.6 263.4 462 263.3 464.3 281.4 463.3 281.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "515.4 276.7 514.4 258.5 515.8 258.4 516.4 276.6 515.4 276.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "474.8 280.7 472.8 262.5 474.2 262.4 475.8 280.6 474.8 280.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "489.8 279.6 488.1 261.4 489.4 261.3 490.8 279.5 489.8 279.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "525.6 273.9 525.3 255.6 526.7 255.5 526.6 273.8 525.6 273.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "503.6 278.6 502.1 260.4 503.5 260.3 504.6 278.6 503.6 278.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M427.1,333.3s23,4.8,54.8,3c5.8-.3,10.7,4.1,11,9.9l4.2,84.8c.3,5.5-3.8,10.3-9.2,10.9-11.7,1.3-32,1.7-49.7-6.2l-11.2-102.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M543.5,323.2s-6.9,5.4-18.9,9.2c-3,.9-5,3.9-4.7,7l6.2,86.3c.3,4.3,4.5,7.3,8.7,6.2,4.3-1.2,9.3-2.8,12.9-4.8l-4.2-103.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "534.5 437.7 528.9 320.2 540.1 315.8 544.5 433.6 534.5 437.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M441.8,291.4s-11.1,11.8-13.2,24.6l14.9,124.1s10.2,3.9,30.1,2l-8.2-128.7s.2-13.5,3.9-20.7c0,0-16.4-.7-27.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M428.6,316s13.5,3.3,37.1,2.2c0,0-2-13.6,3.5-25.6l-27.5-1.2s-11.1,12.4-13.2,24.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M606.4,157.2h-.9c-6.9,1.1-13.4-3.2-15.1-10l-6.6-26.2-4.9-19.3c-1.7-6.7,2-13.6,8.5-16,7.4-2.7,15.6,1.5,17.7,9.2l12.3,45.4c2.1,7.8-3.1,15.7-11.1,16.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M583.9,121.1l-4.9-19.3c-1.7-6.7,2-13.6,8.5-16,7.4-2.7,15.6,1.5,17.7,9.2l4.7,17.5c-18.4-.9-26,8.6-26,8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M604.7,93.5s-7.7,1.5-3.8,19.4c3.9,17.9,17,29.5,17,29.5,0,0-6.7-25.5-13.2-48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.2,103.1s4.7,3.9,8.2,16.8c3.5,13,1.1,21.8,1.1,21.8l-9.4-38.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M613.6,143.6s-2.3.7-2.7,3.1c-.4,2.5.8,3.8.8,3.8,0,0,4.3-1.6,2-6.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M576.5,146.3l-.5.2c-4,1.9-8.8.4-11.1-3.4l-8.8-14.9-6.5-11c-2.3-3.8-1.3-8.7,2.3-11.4,4.1-3,9.9-1.9,12.5,2.4l15.9,25.7c2.7,4.4,1,10.2-3.7,12.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M556,128.2l-6.5-11c-2.3-3.8-1.3-8.7,2.3-11.4,4.1-3,9.9-1.9,12.5,2.4l6.1,9.9c-11.5,2.8-14.4,10.1-14.4,10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M563.8,107.4s-4.5,2.3,1.2,12.6c5.7,10.3,15.9,15.1,15.9,15.1,0,0-8.8-14.5-17-27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M550.4,117.7s3.6,1.5,8.1,8.9c4.5,7.3,4.7,13.2,4.7,13.2l-12.8-22.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M578.4,136.6s-1.3.9-1.1,2.4c.2,1.6,1.2,2.2,1.2,2.2,0,0,2.4-1.8,0-4.6Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalAntibioticGuide);
export default __webpack_public_path__ + "static/media/DentalAntibioticGuide.b936de5187a8e27044114ba5266c6a11.svg";
export { ForwardRef as ReactComponent };